import React from 'react'

const MenuItemIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" {...props} width={props?.size ?? 28} height={props?.size ?? 28} viewBox="0 0 20 20" fill="none">
            <path d="M8.33203 16.25H11.6654M8.88759 18.3333H11.1098" stroke="#8C92A2" strokeWidth="1.25" strokeLinecap="round" />
            <path d="M6.17679 11.4017L7.09682 12.2677C7.35494 12.5106 7.5013 12.8493 7.5013 13.2038C7.5013 13.7363 7.93297 14.168 8.46546 14.168H11.5371C12.0696 14.168 12.5013 13.7363 12.5013 13.2038C12.5013 12.8493 12.6477 12.5106 12.9058 12.2677L13.8258 11.4017C15.1101 10.1836 15.8273 8.5833 15.8346 6.91958L15.8346 6.84969C15.8346 4.00705 13.223 1.66797 10.0013 1.66797C6.77964 1.66797 4.16797 4.00705 4.16797 6.84969L4.16802 6.91958C4.17526 8.5833 4.89246 10.1836 6.17679 11.4017Z" stroke="#8C92A2" strokeWidth="1.25" />
        </svg>
    )
}

export default MenuItemIcon